// src/modules/app-views/dataSearch/pages/Search/modals/InfoModal/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import infoModalStep from './Step1';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const MODAL_WIDTH = 600;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const InfoModal = ({ show, setShow, afterClose }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const steps = useMemo(() => [infoModalStep()], []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleFinish = async () => {
    // Informational modal - just close on confirm
    return true;
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<InfoCircleOutlined />}
      title="how_to_use_data_search"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={MODAL_WIDTH}
      maskClosable={true}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InfoModal;

// *******************************************************************************
// HELPERS
// *******************************************************************************
